var _excluded = ["children", "className", "kind"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * Status: *in progress*.
 * Category: Style
 *
 * Work remaining:
 *
 * - Consider doing some basic styling for `<p>` on a global level. Current implementation requires class .paragraph to get any styling.
 * - Consider if max-width (for readability) should be implemented on the paragraph or in the context
 * - There may be a need for more variations
 */

var Paragraph = function Paragraph(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      kind = _ref.kind,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("p", _extends({
    className: classnames('paragraph', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "paragraph--".concat(kind), kind), _classnames))
  }, rest), children);
};

Paragraph.propTypes = {
  /** One of 'fineprint' or 'preamble'. */
  kind: PropTypes.oneOf(['fineprint', 'preamble'])
};
export default Paragraph;